import { createContext, PropsWithChildren } from 'react';
import { useBannerManager } from '@/providers/BannerProvider/BannerContext.hooks';
import { IBannerContext } from '@/providers/BannerProvider/BannerContext.types';

export const BannerContext = createContext<Partial<IBannerContext>>({});

export const BannerProvider = ({ children }: PropsWithChildren) => {
  const { bannerIds, bannersOffset, registerBanner } = useBannerManager();

  const VALUE: IBannerContext = {
    bannerIds,
    bannersOffset,
    registerBanner,
  };

  return <BannerContext.Provider value={VALUE}>{children}</BannerContext.Provider>;
};
